import * as React from "react";
import { useRoutes } from "react-router-dom";
import Dashboard from "./layouts/index";
// import Footer from './layouts/dashboard/footer';
import Login from "./pages/login";
import Home from "./pages/home";
import Shortner from "./pages/shortner";
import Error from "./pages/error";
import Stores from "./pages/stores/index";
import StoreCreate from "./pages/stores/create";
import StoreEdit from "./pages/stores/edit";
import Users from "./pages/users/index";
import Blacklists from "./pages/blacklist/index";
import Settings from "./pages/settings/index";
import Deals from "./pages/deals/index";
import Exits from "./pages/exits/index";
import Funnels from "./pages/funnels/index";
import Signup from "./pages/leaderboard/signup";
import Leaderboard from "./pages/leaderboard/index";
import LeaderboardOrSignup from "./pages/leaderboard/leaderIndex";
import FlashSignup from "./pages/leaderboard-Flash-clash/signup";
import FlashLeaderboard from "./pages/leaderboard-Flash-clash/index";
import FlashLeaderboardOrSignup from "./pages/leaderboard-Flash-clash/leaderIndex";
import MahaBachatSignup from "./pages/leaderboard-MahaBachat/signup";
import MahaBachatLeaderboard from "./pages/leaderboard-MahaBachat/index";
import MahaBachatLeaderboardOrSignup from "./pages/leaderboard-MahaBachat/leaderIndex";
import AdminLogin from "./pages/admin/login";
import AdminIndex from "./pages/admin/index";
import AdminFlashIndex from "./pages/admin/flashIndex";
import BachatIndex from "./pages/admin/bachatIndex";
import MatchSignup from "./pages/matchKaro/signup";
import MatchIndex from "./pages/matchKaro/index";
import MatchOrSignup from "./pages/matchKaro/matchIndex";
import BeautyIndex from "./pages/biggest-beauty-star/index";
import BeautySignUp from "./pages/biggest-beauty-star/signup";
import BeautyLeaderIndex from "./pages/biggest-beauty-star/leaderIndex";
import DailyBonanzaIndex from "./pages/dailyBonanza/bonanzaIndex";
import BeautyAdmin from "./pages/admin/beautyIndex";

// import Loader from './component/loader';
import Logout from "./components/logout";
import VipPass from "./pages/vip-pass-new-user/VipPass";
import VipPassLapsed from "./pages/vip-pass-lapsed-user/VipPass";
import VipPassPrevious from "./pages/vip-pass-previous-user/VipPass";
import ActivatePass from "./pages/vip-pass-new-user/components/ActivatePass";
import PassActivated from "./pages/vip-pass-new-user/PassActivated";
import PassActivatedLapsed from "./pages/vip-pass-lapsed-user/PassActivated";
import PassActivatedPrevious from "./pages/vip-pass-previous-user/PassActivated";
import VipPassActivated from "./pages/vip-pass-new-user/ActivatedVipPass";
import VipPassActivatedLapsed from "./pages/vip-pass-lapsed-user/ActivatedVipPass";
import VipPassActivatedPrevious from "./pages/vip-pass-previous-user/ActivatedVipPass";

import DiwaliSignup from "./pages/diwali-league/signup";
import DiwaliLeague from "./pages/diwali-league/index";
import Register from "./pages/diwali-league/register";
import PlayPoints from "./pages/diwali-league/playPoints";
import DiscoverBrand from "./pages/diwali-league/discoverBrand";
import ShopAndCollect from "./pages/diwali-league/shopAndCollect";
import ShopFromBrand from "./pages/diwali-league/shopFromBrand";
import MaintainShopping from "./pages/diwali-league/maintainShopping";
import AchievePoints from "./pages/diwali-league/achievePoints";
import Higher from "./pages/diwali-league/higer";
import Milestone from "./pages/diwali-league/milestone";
import PrizeWin from "./pages/diwali-league/prizeWin";
import NormalTable from "./components/diwali/normalTable";
import VipPassOctNew from "./pages/vip-pass-new-user-october/VipPass";
import PassActivatedOctNew from "./pages/vip-pass-new-user-october/PassActivated";
import ActivatedVipPassOctNew from "./pages/vip-pass-new-user-october/ActivatedVipPass";
import VipPassOctLapsed from "./pages/vip-pass-lapsed-user-october/VipPass";
import PassActivatedOctLapsed from "./pages/vip-pass-lapsed-user-october/PassActivated";
import ActivatedVipPassOctLapsed from "./pages/vip-pass-lapsed-user-october/ActivatedVipPass";

// For booking
import BookingSignup from "./pages/booking/signup";
import BookingIndex from './pages/booking/index';
import VipPassNovLapsed from "./pages/vip-pass-lapsed-user-november/VipPass";
import PassActivatedNovLapsed from "./pages/vip-pass-lapsed-user-november/PassActivated";
import ActivatedVipPassNovLapsed from "./pages/vip-pass-lapsed-user-november/ActivatedVipPass";
import VipPassNovNew from "./pages/vip-pass-new-user-november/VipPass";
import PassActivatedNovNew from "./pages/vip-pass-new-user-november/PassActivated";
import ActivatedVipPassNovNew from "./pages/vip-pass-new-user-november/ActivatedVipPass";
import VisitAndEarn from "./pages/diwali-league/visitAndEarn";

//Saving-league 2.0
import SavingLeagueSignup from "./pages/savings-league/signup";
import SavingLeague from "./pages/savings-league/index";
import SavingsLeaguePrizeWin from "./pages/savings-league/prizeWin";
import SavingsLeaguePlayPoint from "./pages/savings-league/playPoints";
import SavingsLeaguediscoverBrand from "./pages/savings-league/discoverBrand";
import SavingsLeagueShopCollect from "./pages/savings-league/shopAndCollect";
import SavingsLeagueShopFromBrand from "./pages/savings-league/shopFromBrand";
import SavingsLeagueMaintainShopping from "./pages/savings-league/maintainShopping";
import SavingsLeagueHigher from "./pages/savings-league/higer";
import SavingsLeagueMilestone from "./pages/savings-league/milestone";
import SavingsLeagueAchievePoints from "./pages/savings-league/achievePoints";
import FreeMoney from "./pages/savings-league/freeMoney";
import MysteryBox from "./pages/mystery-box";
import Congrats from "./pages/mystery-box/congratulation";
import Bonus from "./pages/mystery-box/bonusPage";

import MarchMysteryBox from "./pages/mystery-box-march";
import MarchCongrats from "./pages/mystery-box-march/congratulation";
import MarchBonus from "./pages/mystery-box-march/bonusPage";

import MoneyFiesta from "./pages/money-fiesta";
import Congratss from "./pages/money-fiesta/congratulation";
import Bonuss from "./pages/money-fiesta/bonusPage";
import MoneyFiestaMarch from "./pages/money-fiesta-march";
import MoneyFiestaCongratsMarch from "./pages/money-fiesta-march/congratulation";
import MoneyFiestaBonusMarch from "./pages/money-fiesta-march/bonusPage";
import MysteryBoxApril from "./pages/mystery-box-april";
import MysteryBoxCongratsApril from "./pages/mystery-box-april/congratulation";
import MysteryBoxBonusApril from "./pages/mystery-box-april/bonusPage";
import MysteryBoxMay from "./pages/mystery-box-may";
import MysteryBoxCongratsMay from "./pages/mystery-box-may/congratulation";
import MysteryBoxBonusMay from "./pages/mystery-box-may/bonusPage";

import MoneyFiestaMaySegment from "./pages/money-fiesta-may-segment/index";
import MoneyFiestaCongratsMaySegment from "./pages/money-fiesta-may-segment/congratulation";
import MoneyFiestaBonusMaySegment from "./pages/money-fiesta-may-segment/bonusPage";

import MoneyFiestaMaySegmentTg from "./pages/money-fiesta-may-tg/index";
import MoneyFiestaCongratsMaySegmentTg from "./pages/money-fiesta-may-tg/congratulation";
import MoneyFiestaBonusMaySegmentTg from "./pages/money-fiesta-may-tg/bonusPage";
import CampaignError from "./pages/campaign-error";


import MysteryBoxDec from "./pages/mystery-box-dec";
import MysteryBoxCongratsDec from "./pages/mystery-box-dec/congratulation";
import MysteryBoxBonusDec from "./pages/mystery-box-dec/bonusPage";

import MysteryBoxJan from "./pages/mystery-box-jan";
import MysteryBoxCongratsJan from "./pages/mystery-box-jan/congratulation";
import MysteryBoxBonusJan from "./pages/mystery-box-jan/bonusPage";

import MysteryBoxFeb from "./pages/mystery-box-feb";
import MysteryBoxCongratsFeb from "./pages/mystery-box-feb/congratulation";
import MysteryBoxBonusFeb from "./pages/mystery-box-feb/bonusPage";

import MysteryBoxMarchNew from "./pages/mystery-box-marchh";
import MysteryBoxCongratsMarchNew from "./pages/mystery-box-marchh/congratulation";
import MysteryBoxBonusMarchNew from "./pages/mystery-box-marchh/bonusPage";

import MysteryBoxAprilNew from "./pages/mystery-box-april-new";
import MysteryBoxCongratsAprilNew from "./pages/mystery-box-april-new/congratulation";
import MysteryBoxBonusAprilNew from "./pages/mystery-box-april-new/bonusPage";

import MysteryBoxMayNew from "./pages/mystery-box-may-new";
import MysteryBoxCongratsMayNew from "./pages/mystery-box-may-new/congratulation";
import MysteryBoxBonusMayNew from "./pages/mystery-box-may-new/bonusPage";

import MysteryBoxMarchNewCg from "./pages/mystery-box-marchh-cg";
import MysteryBoxCongratsMarchNewCg from "./pages/mystery-box-marchh-cg/congratulation";
import MysteryBoxBonusMarchNewCg from "./pages/mystery-box-marchh-cg/bonusPage";


export default function Router() {
  const aat = localStorage.getItem("ck_aat");
  const bundle = localStorage.getItem("ck_bundle");
  const ck_id = localStorage.getItem("ck_id");
  // mystery-box-may-new closes after 31st May 2026 (end of day IST)
  const isMysteryBoxMayNewClosed = new Date() > new Date("2026-05-31T23:59:59+05:30");
  let isLoggedIn = false;
  if (aat && bundle) {
    isLoggedIn = true;
  }
  return useRoutes(
    isLoggedIn
      ? [
        {
          path: "/",
          element: <Dashboard />,
          children: [
            { path: "/", element: <Home /> },
            { path: "/stores", element: <Stores /> },
            { path: "/exits", element: <Exits /> },
            { path: "/stores/create", element: <StoreCreate /> },
            { path: "/stores/edit", element: <StoreEdit /> },
            { path: "/users", element: <Users /> },
            { path: "/blacklists", element: <Blacklists /> },
            { path: "/settings", element: <Settings /> },
            { path: "/deals", element: <Deals /> },
            { path: "/funnels", element: <Funnels /> },
            { path: "/leaderboard", element: <LeaderboardOrSignup /> },
            {
              path: "/maha-bachat/index",
              element: <MahaBachatLeaderboardOrSignup />,
            },
            {
              path: "/flash-clash/index",
              element: <FlashLeaderboardOrSignup />,
            },
            { path: "/beauty-star/index", element: <BeautyLeaderIndex /> },
            // {path: "/admin/login", element:<AdminLogin />},
            // {path: "/admin/index", element:<AdminIndex />},
          ],
        },
        { path: "/logout", element: <Logout /> },
      ]
      : [
        {
          path: "/login",
          element: <Login />,
          children: [{ path: "/login", element: <Login /> }],
        },
        { path: "/admin/login", element: <AdminLogin /> },
        { path: "/admin/index", element: <AdminIndex /> },
        // { path: "/admin-flash/login", element: <FlashLogin /> },
        { path: "/admin-flash", element: <AdminFlashIndex /> },
        { path: "/admin-bachat", element: <BachatIndex /> },
        { path: "/admin-beauty", element: <BeautyAdmin /> },
        { path: "/:id", element: <Shortner /> },
        { path: "/leaderboard", element: <LeaderboardOrSignup /> },
        { path: "/match/index", element: <MatchOrSignup /> },
        { path: "/flash-clash/index", element: <FlashLeaderboardOrSignup /> },
        {
          path: "/maha-bachat/index",
          element: <MahaBachatLeaderboardOrSignup />,
        },
        { path: "/beauty-star/index", element: <BeautyLeaderIndex /> },
        { path: "/daily-bonanza/index", element: <DailyBonanzaIndex /> },
        { path: "/vip-pass-new-user/index", element: <VipPass /> },
        { path: "/vip-pass-lapsed-user/index", element: <VipPassLapsed /> },
        { path: "/vip-pass-active-user/index", element: <VipPassPrevious /> },
        { path: "/vip-pass-new-user/activated", element: <PassActivated /> },
        { path: "/vip-pass-new-user/active", element: <VipPassActivated /> },
        { path: "/vip-pass-lapsed-user/active", element: <VipPassActivatedLapsed /> },
        { path: "/vip-pass-active-user/active", element: <VipPassActivatedPrevious /> },
        { path: "/vip-pass-lapsed-user/activated", element: <PassActivatedLapsed /> },
        { path: "/vip-pass-active-user/activated", element: <PassActivatedPrevious /> },
        { path: "/diwali-league/index", element: <DiwaliLeague /> },
        { path: "/diwali-league/signup", element: <DiwaliSignup /> },
        { path: "/diwali-league/register", element: <Register /> },
        { path: "/diwali-league/play-point", element: <PlayPoints /> },
        { path: "/diwali-league/discover-brand", element: <DiscoverBrand /> },
        { path: "/diwali-league/shop-collect", element: <ShopAndCollect /> },
        { path: "/diwali-league/shop-brand", element: <ShopFromBrand /> },
        { path: "/diwali-league/maintain-shop", element: <MaintainShopping /> },
        { path: "/diwali-league/achive-points", element: <AchievePoints /> },
        { path: "/diwali-league/prize-win", element: <PrizeWin /> },
        { path: "/diwali-league/table", element: <NormalTable /> },

        //saving-league
        { path: "/savings-league/index", element: <SavingLeague /> },
        { path: "/savings-league/signup", element: <SavingLeagueSignup /> },
        { path: "/savings-league/prize-win", element: <SavingsLeaguePrizeWin /> },
        { path: "/savings-league/play-point", element: <SavingsLeaguePlayPoint /> },
        { path: "/savings-league/discover-brand", element: <SavingsLeaguediscoverBrand /> },
        { path: "/savings-league/shop-collect", element: <SavingsLeagueShopCollect /> },
        { path: "/savings-league/shop-brand", element: <SavingsLeagueShopFromBrand /> },
        { path: "/savings-league/maintain-shop", element: <SavingsLeagueMaintainShopping /> },
        { path: "/savings-league/higher", element: <SavingsLeagueHigher /> },
        { path: "/savings-league/milestone", element: <SavingsLeagueMilestone /> },
        { path: "/savings-league/achive-points", element: <SavingsLeagueAchievePoints /> },
        { path: "/savings-league/free-money", element: <FreeMoney /> },



        { path: "/vip-pass-oct-new-user/index", element: <VipPassOctNew /> },
        { path: "/vip-pass-oct-new-user/activated", element: <PassActivatedOctNew /> },
        { path: "/vip-pass-oct-new-user/active", element: <ActivatedVipPassOctNew /> },

        { path: "/vip-pass-oct-lapsed-user/index", element: <VipPassOctLapsed /> },
        { path: "/vip-pass-oct-lapsed-user/activated", element: <PassActivatedOctLapsed /> },
        { path: "/vip-pass-oct-lapsed-user/active", element: <ActivatedVipPassOctLapsed /> },

        { path: "/vip-pass-nov-lapsed-user/index", element: <VipPassNovLapsed /> },
        { path: "/vip-pass-nov-lapsed-user/activated", element: <PassActivatedNovLapsed /> },
        { path: "/vip-pass-nov-lapsed-user/active", element: <ActivatedVipPassNovLapsed /> },

        { path: "/vip-pass-nov-new-user/index", element: <VipPassNovNew /> },
        { path: "/vip-pass-nov-new-user/activated", element: <PassActivatedNovNew /> },
        { path: "/vip-pass-nov-new-user/active", element: <ActivatedVipPassNovNew /> },


        { path: "/diwali-league/higher", element: <Higher /> },
        { path: "/diwali-league/milestone", element: <Milestone /> },

        { path: "/booking/signup", element: <BookingSignup /> },
        { path: "/booking/index", element: <BookingIndex /> },

        // {path:"/matchkaro/index", element:<MatchIndex />},
        // {path:"/matchkaro/signup", element:<MatchSignup />},

        { path: "/", element: <Error /> },
        { path: "/diwali-league/visit-earn", element: <VisitAndEarn /> },

        { path: '/mystery-box/index', element: <MysteryBox /> },
        { path: '/mystery-box/congrats', element: <Congrats /> },
        { path: '/mystery-box/bonus', element: <Bonus /> },

        { path: '/mystery-box-march/index', element: <MarchMysteryBox /> },
        { path: '/mystery-box-march/congrats', element: <MarchCongrats /> },
        { path: '/mystery-box-march/bonus', element: <MarchBonus /> },


        { path: '/mystery-box-april/index', element: <MysteryBoxApril /> },
        { path: '/mystery-box-april/congrats', element: <MysteryBoxCongratsApril /> },
        { path: '/mystery-box-april/bonus', element: <MysteryBoxBonusApril /> },

        { path: '/mystery-box-may/index', element: <MysteryBoxMay /> },
        { path: '/mystery-box-may/congrats', element: <MysteryBoxCongratsMay /> },
        { path: '/mystery-box-may/bonus', element: <MysteryBoxBonusMay /> },

        //   { path: '/mystery-box-june/index', element: <h1>Campaign Closed</h1> },
        // { path: '/mystery-box-june/congrats', element: <h1>Campaign Closed</h1> },
        // { path: '/mystery-box-june/bonus', element: <h1>Campaign Closed</h1> },


     

           { path: '/mystery-box-july/index', element:<h1>Campaign Closed</h1> },
        { path: '/mystery-box-july/congrats', element:<h1>Campaign Closed</h1> },
        { path: '/mystery-box-july/bonus', element: <h1>Campaign Closed</h1> },

        { path: '/mystery-box-aug/index', element: <h1>Campaign Closed</h1> },
        { path: '/mystery-box-aug/congrats', element: <h1>Campaign Closed</h1> },
        { path: '/mystery-box-aug/bonus', element: <h1>Campaign Closed</h1> },

        { path: '/mystery-box-nov/index', element: <h1 style={{textAlign:'center'}}>Campaign Closed</h1>},
        { path: '/mystery-box-nov/congrats', element: <h1 style={{textAlign:'center'}}>Campaign Closed</h1> },
        { path: '/mystery-box-nov/bonus', element: <h1 style={{textAlign:'center'}}>Campaign Closed</h1> },

        { path: '/mystery-box-dec/index', element: <h1 style={{textAlign:'center'}}>Campaign Closed</h1> },
        { path: '/mystery-box-dec/congrats', element: <MysteryBoxCongratsDec/> },
        { path: '/mystery-box-dec/bonus', element: <MysteryBoxBonusDec/> },

        { path: '/mystery-box-jan/index', element: <h1 style={{textAlign:'center'}}>Campaign Closed</h1> },
        { path: '/mystery-box-jan/congrats', element: <MysteryBoxCongratsJan/> },
        { path: '/mystery-box-jan/bonus', element: <MysteryBoxBonusJan/> },

        { path: '/mystery-box-feb/index', element: <MysteryBoxFeb/> },
        { path: '/mystery-box-feb/congrats', element: <MysteryBoxCongratsFeb/> },
        { path: '/mystery-box-feb/bonus', element: <MysteryBoxBonusFeb/> },

        { path: '/mystery-box-march-new/index', element: <h1>Campaign Closed</h1> },
        { path: '/mystery-box-march-new/congrats', element: <MysteryBoxCongratsMarchNew/> },
        { path: '/mystery-box-march-new/bonus', element: <MysteryBoxBonusMarchNew/> },

        { path: '/mystery-box-april-new/index', element: <h1>Campaign Closed</h1> },

        { path: '/mystery-box-april-new/congrats', element: <MysteryBoxCongratsAprilNew/> },
        { path: '/mystery-box-april-new/bonus', element: <MysteryBoxBonusAprilNew/> },

        { path: '/mystery-box-may-new/index', element: isMysteryBoxMayNewClosed ? <h1 style={{textAlign:'center'}}>Campaign Closed</h1> : <MysteryBoxMayNew/> },
        { path: '/mystery-box-may-new/congrats', element: <MysteryBoxCongratsMayNew/> },
        { path: '/mystery-box-may-new/bonus', element: <MysteryBoxBonusMayNew/> },

        // { path: '/mystery-box-june-new/index', element: <h1>Campaign Closed</h1> },
        // { path: '/mystery-box-june-new/congrats', element: <MysteryBoxCongratsJuneNew/> },
        // { path: '/mystery-box-june-new/bonus', element: <MysteryBoxBonusJuneNew/> },

        { path: '/mystery-box-march-new-cg/index', element: <MysteryBoxMarchNewCg/> },
        { path: '/mystery-box-march-new-cg/congrats', element: <MysteryBoxCongratsMarchNewCg/> },
        { path: '/mystery-box-march-new-cg/bonus', element: <MysteryBoxBonusMarchNewCg/> },

        { path: '/money-fiesta/index', element: <MoneyFiesta /> },
        { path: '/money-fiesta/congrats', element: <Congratss /> },
        { path: '/money-fiesta/bonus', element: <Bonuss /> },

        { path: '/money-fiesta-march/index', element: <MoneyFiestaMarch /> },
        { path: '/money-fiesta-march/congrats', element: <MoneyFiestaCongratsMarch /> },
        { path: '/money-fiesta-march/bonus', element: <MoneyFiestaBonusMarch /> },

        { path: '/money-fiesta-april/index', element: <h1 style={{textAlign:'center'}}>Campaign Closed</h1> },
        { path: '/money-fiesta-april/congrats', element: <h1 style={{textAlign:'center'}}>Campaign Closed</h1> },
        { path: '/money-fiesta-april/bonus', element: <h1 style={{textAlign:'center'}}>Campaign Closed</h1> },

      

        { path: '/money-fiesta-may-segment/index', element: <MoneyFiestaMaySegment /> },
        { path: '/money-fiesta-may-segment/congrats', element: <MoneyFiestaCongratsMaySegment /> },
        { path: '/money-fiesta-may-segment/bonus', element: <MoneyFiestaBonusMaySegment /> },

        // { path: '/money-fiesta-june-segment/index', element: <MoneyFiestaJuneSegment /> },
        // { path: '/money-fiesta-june-segment/congrats', element: <MoneyFiestaCongratsJuneSegment /> },
        // { path: '/money-fiesta-june-segment/bonus', element: <MoneyFiestaBonusJuneSegment /> },

        { path: '/money-fiesta-june/index', element: <h1 style={{textAlign:'center'}}>Campaign Closed</h1> },
        { path: '/money-fiesta-june/congrats', element: <h1 style={{textAlign:'center'}}>Campaign Closed</h1> },
        { path: '/money-fiesta-june/bonus', element: <h1 style={{textAlign:'center'}}>Campaign Closed</h1> },

        // { path: '/money-fiesta-july/index', element: <MoneyFiestajuly /> },
        // { path: '/money-fiesta-july/congrats', element: <MoneyFiestaCongratsjuly /> },
        // { path: '/money-fiesta-july/bonus', element: <MoneyFiestaBonusjuly /> },

        { path: '/money-fiesta-august/index', element: <h1 style={{textAlign:'center'}}>Campaign Closed</h1> },
        { path: '/money-fiesta-august/congrats', element: <h1 style={{textAlign:'center'}}>Campaign Closed</h1> },
        { path: '/money-fiesta-august/bonus', element: <h1 style={{textAlign:'center'}}>Campaign Closed</h1> },

        // { path: '/money-fiesta-nov/index', element: <MoneyFiestaNov /> },
        // { path: '/money-fiesta-nov/congrats', element: <MoneyFiestaCongratsNov /> },
        // { path: '/money-fiesta-nov/bonus', element: <MoneyFiestaBonusNov /> },

        { path: '/money-fiesta-dec/index', element: <h1 style={{textAlign:'center'}}>Campaign Closed</h1> },
        { path: '/money-fiesta-dec/congrats', element: <h1 style={{textAlign:'center'}}>Campaign Closed</h1> },
        { path: '/money-fiesta-dec/bonus', element: <h1 style={{textAlign:'center'}}>Campaign Closed</h1> },

        { path: '/money-fiesta-jan/index', element: <h1 style={{textAlign:'center'}}>Campaign Closed</h1> },
        { path: '/money-fiesta-jan/congrats', element: <h1 style={{textAlign:'center'}}>Campaign Closed</h1> },
        { path: '/money-fiesta-jan/bonus', element: <h1 style={{textAlign:'center'}}>Campaign Closed</h1> },

        { path: '/money-fiesta-feb/index', element: <h1 style={{textAlign:'center'}}>Campaign Closed</h1> },
        { path: '/money-fiesta-feb/congrats', element: <h1 style={{textAlign:'center'}}>Campaign Closed</h1> },
        { path: '/money-fiesta-feb/bonus', element: <h1 style={{textAlign:'center'}}>Campaign Closed</h1> },

        // { path: '/money-fiesta-march-new/index', element: <MoneyFiestaMarchNew /> },
        // { path: '/money-fiesta-march-new/congrats', element: <MoneyFiestaCongratsMarchNew /> },
        // { path: '/money-fiesta-march-new/bonus', element: <MoneyFiestaBonusMarchNew /> },

        // { path: '/money-fiesta-april-new/index', element: <MoneyFiestaAprilNew /> },
        // { path: '/money-fiesta-april-new/congrats', element: <MoneyFiestaCongratsAprilNew /> },
        // { path: '/money-fiesta-april-new/bonus', element: <MoneyFiestaBonusAprilNew /> },

        // { path: '/money-fiesta-may-new/index', element: <MoneyFiestaMayNew /> },
        // { path: '/money-fiesta-may-new/congrats', element: <MoneyFiestaCongratsMayNew /> },
        // { path: '/money-fiesta-may-new/bonus', element: <MoneyFiestaBonusMayNew /> },

        // { path: '/money-fiesta-june-new/index', element: <MoneyFiestaJuneNew /> },
        // { path: '/money-fiesta-june-new/congrats', element: <MoneyFiestaCongratsJuneNew /> },
        // { path: '/money-fiesta-june-new/bonus', element: <MoneyFiestaBonusJuneNew /> },

        { path: '/money-fiesta-june-new/index', element: <h1 style={{textAlign:'center'}}>Campaign Closed</h1> },
        { path: '/money-fiesta-june-new/second-congrats', element: <h1 style={{textAlign:'center'}}>Campaign Closed</h1> },
        { path: '/money-fiesta-june-new/second-bonus', element: <h1 style={{textAlign:'center'}}>Campaign Closed</h1> },
        { path: '/money-fiesta-june-new/congrats', element: <h1 style={{textAlign:'center'}}>Campaign Closed</h1> },
        { path: '/money-fiesta-june-new/bonus', element: <h1 style={{textAlign:'center'}}>Campaign Closed</h1> },

        // { path: '/money-fiesta-july-new/index', element: <MoneyFiestaJulyNewTest /> },
        // { path: '/money-fiesta-july-new/second-congrats', element: <MoneyFiestaCongratsJulyNewTest2 /> },
        // { path: '/money-fiesta-july-new/second-bonus', element: <MoneyFiestaBonusJulyNewBonusTest /> },
        // { path: '/money-fiesta-july-new/congrats', element: <MoneyFiestaCongratsJulyNewTest /> },
        // { path: '/money-fiesta-july-new/bonus', element: <MoneyFiestaBonusJulyNewTest /> },


        { path: '/money-fiesta-may-tg/index', element: <MoneyFiestaMaySegmentTg /> },
        { path: '/money-fiesta-may-tg/congrats', element: <MoneyFiestaCongratsMaySegmentTg /> },
        { path: '/money-fiesta-may-tg/bonus', element: <MoneyFiestaBonusMaySegmentTg /> },

        { path: '/bhavik', element: <h1>hello</h1> },

        { path: '/campaign-error', element: <CampaignError /> }



      ]
  );
}
